"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDittoContext = exports.DittoContext = void 0;
var react_1 = require("react");
exports.DittoContext = (0, react_1.createContext)({
    dittoHash: {},
    load: function () { return Promise.resolve(); },
    isLazy: false,
});
var useDittoContext = function () {
    var dittoContext = (0, react_1.useContext)(exports.DittoContext);
    if (!dittoContext)
        throw new Error('useDittoContext must be called within a DittoProvider tag');
    return dittoContext;
};
exports.useDittoContext = useDittoContext;
//# sourceMappingURL=DittoContext.js.map